"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
var Status;
(function (Status) {
    Status["active"] = "active";
    Status["paused"] = "paused";
    Status["archived"] = "archived";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=Survey.js.map